import axios from 'axios';
import { parseDateForDisplay } from '../commons/componentes/DateFormat';

export interface CalcularDiaVencimientoRequest {
  rfc: string;
  mes: number;
  anio: number;
  masDias?: number | null;
  menosDias?: number | null;
}

export interface CalcularDiaVencimientoResponse {
  rfc: string;
  mes: number;
  anio: number;
  fechaBase: string;
  fechaBaseReal: string;
  fechaVencimiento: string;
  diasAdicionalesRfc: number;
  fechaMenosDias?: string | null;
  fechaMasDias?: string | null;
}

export const DIA_VENCIMIENTO_CALCULAR_API = 'api/dia-vencimiento/calcular';

export const MESES_PERIODO = [
  { value: '1', label: 'Enero' },
  { value: '2', label: 'Febrero' },
  { value: '3', label: 'Marzo' },
  { value: '4', label: 'Abril' },
  { value: '5', label: 'Mayo' },
  { value: '6', label: 'Junio' },
  { value: '7', label: 'Julio' },
  { value: '8', label: 'Agosto' },
  { value: '9', label: 'Septiembre' },
  { value: '10', label: 'Octubre' },
  { value: '11', label: 'Noviembre' },
  { value: '12', label: 'Diciembre' },
] as const;

export function buildAnioOptions(centerYear = new Date().getFullYear()): { value: string; label: string }[] {
  const years: { value: string; label: string }[] = [];
  for (let y = centerYear - 2; y <= centerYear + 2; y += 1) {
    years.push({ value: String(y), label: String(y) });
  }
  return years;
}

export function formatFechaVencimientoLong(value: string | null | undefined): string {
  if (!value) return '—';
  const date = parseDateForDisplay(value);
  if (isNaN(date.getTime())) return '—';

  const formatted = new Intl.DateTimeFormat('es-MX', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);

  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}

export async function calcularDiaVencimiento(
  request: CalcularDiaVencimientoRequest,
): Promise<CalcularDiaVencimientoResponse> {
  const payload: CalcularDiaVencimientoRequest = {
    rfc: request.rfc.trim(),
    mes: request.mes,
    anio: request.anio,
  };

  if (request.menosDias != null && request.menosDias > 0) {
    payload.menosDias = request.menosDias;
  }
  if (request.masDias != null && request.masDias > 0) {
    payload.masDias = request.masDias;
  }

  const { data } = await axios.post<CalcularDiaVencimientoResponse>(
    DIA_VENCIMIENTO_CALCULAR_API,
    payload,
  );
  return data;
}

export function extractDiaVencimientoError(err: unknown): string {
  if (axios.isAxiosError(err)) {
    const body = err.response?.data as { detail?: string; message?: string; title?: string } | undefined;
    const msg = body?.detail ?? body?.message ?? body?.title;
    if (typeof msg === 'string' && msg.trim()) return msg;
    if (err.message) return err.message;
  }
  if (err instanceof Error && err.message) return err.message;
  return 'No se pudo calcular el vencimiento.';
}
